import React from 'react'
import PropTypes from 'prop-types'
import classnames from 'classnames'
import get from 'lodash/get'
import { BlockHeader, BlockWrapper, getColor, LocalizedDate, Measure, LocalizedNumber, Badge, Rows } from 'labguard-cdk'
import { useInView } from 'react-intersection-observer'
import ChannelStatus from '../ChannelStatus'
import styles from './ChannelTile.scss'

const ChannelTile = ({ channel, toolbar }) => {
  const [ref, inView] = useInView()

  const content = React.useMemo(
    () => (
      <>
        <Badge
          position={{ top: '-.35rem', right: '-.35rem' }}
          size=".7rem"
          border="body-bg"
          visible={channel.colors.length > 1}
          color={channel.colors[1]}
        />
        <BlockHeader className={styles.header} title={channel.name} toolbar={toolbar} />
        <Rows layout="1 1.5rem" className={styles.content}>
          <Rows layout="auto" align="center" justify="center" gap="0">
            <Measure className={styles.measure} unit={get(channel, 'acqChain.unit.symbol')}>
              <LocalizedNumber value={get(channel, 'lastMeasure.value')} />
            </Measure>
            <div className={styles.date}>
              <LocalizedDate
                value={get(channel, 'lastMeasure.date')}
                day="2-digit"
                month="long"
                year="numeric"
                hour="numeric"
                minute="numeric"
                second="numeric"
              />
            </div>
          </Rows>
          <ChannelStatus channelId={channel.id} />
        </Rows>
      </>
    ),
    [channel, toolbar]
  )

  return (
    <div ref={ref} className={styles.container}>
      <BlockWrapper
        className={classnames(styles.channel, {
          [styles.wink]: inView && get(channel, 'winkingAlarm.toBeAcknowledged', false),
          blink: !inView,
        })}
        style={{ backgroundColor: inView && getColor(channel.colors[0] || 'light') }}
        gap="0"
        layout="auto 1rem 1"
      >
        {inView && content}
      </BlockWrapper>
    </div>
  )
}

ChannelTile.defaultProps = {}

ChannelTile.propTypes = {
  toolbar: PropTypes.node.isRequired,
  channel: PropTypes.shape({
    id: PropTypes.string.isRequired,
    name: PropTypes.string.isRequired,
    nbAlarms: PropTypes.number.isRequired,
    winkingAlarm: PropTypes.shape({
      toBeAcknowledged: PropTypes.bool,
    }),
    colors: PropTypes.arrayOf(PropTypes.string),
    lastMeasure: PropTypes.shape({
      value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
      date: PropTypes.instanceOf(Date),
    }),
    acqChain: PropTypes.shape({
      unit: PropTypes.shape({
        symbol: PropTypes.string,
      }),
    }),
  }).isRequired,
}

export default ChannelTile
